<section class="page-container goals">
  <section>
    <button mat-stroked-button routerLink="/dashboard" class='back-btn'>
      <mat-icon>keyboard_arrow_left</mat-icon>Back to Dashboard
    </button>
  </section>
  <h3>
    {{ getUserFullName() }} |
    <span class="mat-title">Goals</span>
  </h3>

  <section class='mat-elevation-z3 goal-category' *ngFor='let goalCategory of goalCategories$ | async'>
    <app-goal-display [goalCategory]='goalCategory'></app-goal-display>
  </section>
</section>
